import { render, staticRenderFns } from "./ServiceFlow.vue?vue&type=template&id=228ed7e0"
import script from "./ServiceFlow.vue?vue&type=script&lang=js"
export * from "./ServiceFlow.vue?vue&type=script&lang=js"
import style0 from "./ServiceFlow.vue?vue&type=style&index=0&id=228ed7e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports